import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import { createFilterOptions } from '@mui/material/Autocomplete';
import Locations from '../data/Locations.json';

export default function LocationSelect({ setLocation, error, helperText }) {
  const filterOptions = createFilterOptions({
    stringify: ({ location, code }) => `${location} ${code}`,
  });
  return (
    <Autocomplete
      size='small'
      fullWidth
      options={Locations}
      filterOptions={filterOptions}
      autoHighlight
      getOptionLabel={(option) => option.location}
      onChange={setLocation}
      renderOption={(props, option) => (
        <Box
          component='li'
          sx={{ '& > img': { mr: 2, flexShrink: 0 } }}
          {...props}
        >
          {option.location}
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label='Set Location'
          inputProps={{
            ...params.inputProps,
            autoComplete: 'new-password',
          }}
          error={error && error}
          helperText={helperText && helperText}
        />
      )}
    />
  );
}
